import React from "react";
import { FaComputer } from "react-icons/fa6";
import { FaMobileScreenButton } from "react-icons/fa6";
import { Link } from "react-router-dom";


const Section = () => {
  return (
    <div className="bg-[#0c1428] p-4 w-full mt-[80px] ">
      <div className="w-full mb-4">
        <h1 className="text-4xl text-center font-bold text-transparent bg-gradient-to-r from-[#00a6e3] via-[#80a380] to-orange-600 bg-clip-text sm:text-7xl">
          Diseño De Software Mexico
          </h1>
      </div>

      <div className="flex flex-col items-center justify-center text-center text-3xl px-6 pl-10 sm:flex-row sm:w-full ">
        <div className=" border border-[#007fba]  w-full h-[280px] mt-2 mb-8 mr-6 bg-gray-800 rounded-2xl shadow-lg p-6 relative overflow-hidden hover:scale-110 transition-transform duration-300 sm:w-1/3 sm:mt-0 xl:w-[600px] xl:mr-12">
          <h1 className="text-white mt-6">Desarrollo Web</h1>
          <p className="text-white text-2xl 2xl:text-3xl">Impulsa tu presencia en línea</p>

          <div className="flex justify-center space-x-8 p-8 py-4">
         <img
              className="w-[60px] h-[60px] mt-2 sm:mt-8"
              src="assets/webc.png"
              alt="logo.png"
            ></img>
        <Link to="/servicios" >  <img className="w-[70px] h-[70px] mt-2 sm:mt-8" src="/assets/flechaxd.svg" alt="" /></Link>

          </div>
        </div>

        <div className=" border border-[#007fba]  w-full h-[280px] mr-6 mb-8 bg-gray-800 rounded-2xl shadow-lg p-6 relative overflow-hidden  hover:scale-110 transition-transform duration-300 sm:w-1/3 xl:w-[600px] xl:mr-12">
          <h1 className="text-white mt-6">Desarrollo Movil</h1>
          <p className="text-white text-2xl 2xl:text-3xl">Conecta con tus usuarios</p>

          <div className="flex justify-center space-x-8 p-8 py-4">
         <img
              className="w-[60px] mt-2 h-[60px] sm:mt-8"
              src="assets/movilc.png"
              alt="logo.png"
            ></img>
          <Link to="/servicios" > <img className="w-[70px] h-[70px] mt-2 sm:mt-8" src="/assets/flechaxd.svg" alt="" /> </Link>

          </div>
        </div>

        <div className=" border border-[#007fba]  w-full h-[280px] mr-6 mb-8 bg-gray-800 rounded-2xl shadow-lg p-6 relative overflow-hidden hover:scale-110 transition-transform duration-300 sm:w-1/3 xl:w-[600px]">
          <h1 className="text-white mt-6">Desarrollo de Software</h1>
          <p className="text-white text-2xl 2xl:text-3xl">Optimiza tus procesos</p>

          <div className="flex justify-center space-x-8  p-8 py-2 sm:py-4 ">
          <img src="assets/softwarec.png" className="w-[70px] h-[70px] p-2 mt-0 sm:mt-8"/>
          <Link to="/servicios" > <img className="w-[70px] h-[70px] mt-0 sm:mt-8" src="/assets/flechaxd.svg" alt="" /> </Link>

          </div>
        </div>

        

        

        

      </div>
    </div>
  );
};

export default Section;
